import { Box, Button, ClickAwayListener, Slide, Stack, Typography,} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const HeaderSliderMobile = ({ mobileMenuOpen, handleMobileMenuToggle }) => {
  const navigate = useNavigate();
  const [expandedMenu, setExpandedMenu] = useState(null);

  const mobileList = [
    {
      title: "About us",
      path: "/about-us",
    },
    {
      title: "Product",
      children: [
        { label: "WhatsApp Marketing", path: "/whatsapp-marketing" },
        { label: "Click to WhatsApp Ads", path: "/whatsapp-adds" },
        { label: "WhatsApp Chatbots", path: "/whatsapp-chatboat" },
        { label: "WhatsApp Payments", path: "/whatsapp-payment" },
        { label: "WhatsApp Forms", path: "/whatsapp-form" },
        { label: "WhatsApp WebViews", path: "/whatsapp-webview" },
        { label: "WhatsApp Button", path: "/whatsapp-button" },
        { label: "WhatsApp Link & QR", path: "/whatsapp-link" },
      ],
    },

    {
      title: "Industries",
      children: [
        { label: "Education & Edtech", index: 0 },
        { label: "Healthcare", index: 1 },
        { label: "Finance", index: 2 },
        { label: "E-commerce", index: 3 },
        { label: "Retail", index: 4 },
        { label: "Travel & Tourism", index: 5 },
        { label: "Hospitality", index: 6 },
        { label: "Logistics", index: 7 },
        { label: "Real Estate", index: 8 },
        { label: "Insurance", index: 9 },
        { label: "Media & Entertainment", index: 10 },
        { label: "Government Services", index: 11 },
      ],
    },
    {
      title: "Resources",
      children: [
        { label: "Docs", path: "/resources/docs" },
        { label: "Blog", path: "/resources/blog" },
        { label: "FAQs", path: "/resources/faqs" },
      ],
    },
    {
      title: "Integrations",
      children: [
        { label: "Shopify", path: "/integrations/shopify" },
        { label: "Zapier", path: "/integrations/zapier" },
        { label: "WooCommerce", path: "/integrations/woocommerce" },
      ],
    },

    {
      title: "Pricing",
      path: "/price",
    },
  ];

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [mobileMenuOpen]);

  const handleToggle = (title) => {
    setExpandedMenu((prev) => (prev === title ? null : title));
  };

  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const handleIndustriesClick = (index, title) => {
    console.log("cardInfo:", index, title);
    const slug = slugify(title);
    navigate(`/industries-component/${slug}`, { state: { index } });
  };

  return (
    <ClickAwayListener onClickAway={handleMobileMenuToggle}>
      <Box>
        {/* <Slide direction="right" in={mobileMenuOpen} mountOnEnter unmountOnExit > */}
        <Stack
          sx={{
            backgroundColor: "white",
            position: "fixed",
            top: 0,
            right: 0,
            zIndex: 1300,
            width: "80vw",
            height: "100vh",
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            overflowY: "auto",
            // border: "2px solid red"
          }}
        >
          {/* Close Button */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <Button onClick={handleMobileMenuToggle}>
              <MdClose size={24} />
            </Button>
          </Box>

          {/* Menu Items */}
          {mobileList.map((item, index) => (
            <Box key={index}>
              <Box
                onClick={() =>
                  item.children
                    ? handleToggle(item.title)
                    : (navigate(item.path || "/"), handleMobileMenuToggle())
                }
                sx={{
                  padding: "1rem 1.5rem",
                  borderBottom: "1px solid #e0e0e0",
                  cursor: "pointer",
                  fontWeight: "500",
                  fontFamily: "'Roboto', sans-serif",
                }}
              >
                {item.title}
              </Box>

              {/* Submenu Items */}
              {item.children && expandedMenu === item.title && (
                <Stack sx={{ pl: 4, background: "#f9f9f9" }}>
                  {item.children.map((child, i) => (
                    <Typography
                      key={i}
                      variant="body2"
                      // onClick={() => {
                      //   navigate(child.path || "/");
                      //   handleMobileMenuToggle();

                      // }}
                      onClick={() => {
                        if (item.title === "Industries") {
                          handleIndustriesClick(child.index, child.label);
                          handleMobileMenuToggle();
                        } else {
                          navigate(child.path || "/");
                          handleMobileMenuToggle();
                        }
                      }}
                      sx={{
                        py: 1,
                        cursor: "pointer",
                        borderBottom: "1px solid #eee",
                        fontFamily: "'Roboto', sans-serif",
                      }}
                    >
                      {child.label}
                    </Typography>
                  ))}
                </Stack>
              )}
            </Box>
          ))}
        </Stack>
        {/* </Slide> */}
      </Box>
    </ClickAwayListener>
  );
};

export default HeaderSliderMobile;
